<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="machineModel" placeholder="整机型号" clearable>
          <el-option
            v-for="x in selectList"
            :key="x.id"
            :value="x.id"
            :label="x.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="coreModel" placeholder="固件型号" clearable>
          <el-option
            v-for="x in coreModelList"
            :key="x"
            :value="x"
            :label="x"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column prop="machineModel" label="整机型号"> </el-table-column>
      <el-table-column prop="coreModel" label="固件型号"> </el-table-column>
      <el-table-column prop="gyroRange" label="角速度量程">
        <template slot-scope="scope">
          <div v-if="edit == scope.row.deviceId">
            <el-select v-model="gyroRange" placeholder="角速度量程">
              <el-option value="125" label="125dps"></el-option>
              <el-option value="250" label="250dps"></el-option>
              <el-option value="500" label="500dps"></el-option>
              <el-option value="1000" label="1000dps"></el-option>
              <el-option value="2000" label="2000dps"></el-option>
            </el-select>
          </div>
          <div v-else>
            {{ scope.row.gyroRange }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accelRange" label="加速度量程">
        <template slot-scope="scope">
          <div v-if="edit == scope.row.deviceId">
            <el-select v-model="accelRange" placeholder="加速度量程">
              <el-option value="2" label="2G"></el-option>
              <el-option value="4" label="4G"></el-option>
              <el-option value="8" label="8G"></el-option>
              <el-option value="16" label="16G"></el-option>
            </el-select>
          </div>
          <div v-else>
            {{ scope.row.accelRange }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            v-if="edit == scope.row.deviceId"
            @click="Save(scope.row)"
            type="text"
            size="small"
            >保存</el-button
          >
          <el-button
            v-if="edit == scope.row.deviceId"
            @click="Cancel(scope.row)"
            type="text"
            size="small"
            >取消</el-button
          >
          <el-button v-else @click="Edit(scope.row)" type="text" size="small"
            >编辑</el-button
          >
          <el-button @click="Delete(scope.$index)" type="text" size="small" v-if="!!scope.row.id"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      edit: 0,
      deviceId: "",
      machineModel: "",
      coreModel: "",
      accelRange: "",
      gyroRange: "",
      data: [],
      selectList: [],
      coreModelList: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  beforeCreate() {
    this.$http
      .post("/manage/machine/page", {
        pageNum: 1,
        pageSize: 9999,
        kind: "portable",
      })
      .then((data) => {
        this.selectList = data["data"]["data"]["records"].map((i) => {
          return {
            name: `${i.model}-${i.kind}`,
            id: i.model,
          };
        });
      });
    this.$http.post("/manage/range-settings/machineModelList").then((data) => {
      this.coreModelList = data["data"]["data"].map(i => Object.values(i)[0]);
    });
  },
  methods: {
    Delete(index) {
      //单删
      if (confirm("确认要删除吗？")) {
        let ID = this.data[index].id;
        this.$http
          .post("/manage/range-settings/delete", { id: ID })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
      }
    },
    Edit(row) {
      this.edit = row.deviceId;
      this.accelRange = row.accelRange;
      this.gyroRange = row.gyroRange;
    },
    Save(row) {
      row.accelRange = this.accelRange;
      row.gyroRange = this.gyroRange;
      if (row.id) {
        this.$http.post("/manage/range-settings/update", row).then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.edit = 0;
            this.getList();
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
      } else {
        this.$http.post("/manage/range-settings/save", row).then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.edit = 0;
            this.getList();
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
      }
    },
    Cancel(row) {
      this.edit = 0;
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.coreModel) {
        params.coreModel = this.coreModel;
      }
      if (this.machineModel.trim() != "") {
        params.machineModel = this.machineModel;
      }
      this.$http.post("/manage/range-settings/page", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
  },
  components: { Pagination },
};
</script>
